import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/step3.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')